import React, { useState, useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import './index-QrdBfapu.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-5CMab_Gs.js';
import './index-vPolXUOt.js';
import useShowError from './hooks/useShowError.js';
import 'notistack';
import { extractVariantsFromProductName, formatProductName } from './utils/product.js';
import './helpers-qyZpLI0y.js';
import 'lodash';
import useItemListName from './hooks/useItemListName.js';
import { logImgLoadErrorToRelic } from './utils/logToRelic.js';
import './utils/currency.js';
import 'lodash/get';
import { formatPoints } from './utils/price.js';
import './product-_pRduMz7.js';
import 'next/server';
import './index-Oip0gjfj.js';
import './graphqlRequestClient-7kdUKc_c.js';
import { getProductImage, getProductNewPrice, getProductOldPrice, getCartItemStockInfo, getCartSessionId } from './utils/cart.js';
import Loader from './components/Loader/index.js';
import { Q as Quantity } from './Quantity-BHodKRFt.js';
import { R as Remove } from './Remove-yBvNmlSV.js';
import 'react-i18next';
import './types/index.js';
import './checkout-ArxiEbYP.js';
import './menu-0TyOg98i.js';
import './modal-6vnX5SO3.js';
import './types-iWC93EMW.js';
import './index-2586sEvh.js';
import 'next/link';
import 'react-dom';
import './store/modal/index.js';
import './swiper-react-d6QiaAOs.js';
import { P as Prices } from './Prices-RfqmCkHW.js';
import { selectShowPoints } from './store/points/pointsSlice.js';
import 'react-hook-form';
import '@hookform/resolvers/yup';
import 'lodash/pickBy';
import './helper-k_jASZ_1.js';
import 'yup';
import './constants-LkG-Sonv.js';
import './SizeField-JNtoYwfb.js';

const ShoppingCartItemDrawer = ({ item }) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const router = useRouter();
    const [isDeleting, setIsDeleting] = useState(false);
    const { data: { siteConfig: { noZeroAfterDecimal = false }, }, thunks: { cart: { removeItem }, }, useDispatch, useSelector, } = useContext(CoreContext);
    const showPoints = useSelector(selectShowPoints);
    const locale = router.locale;
    const { data: { siteConfig: { productNameFilters, accorTagging: { accorTaggingEnabled = false } = {} }, }, } = useContext(CoreContext);
    const itemListName = useItemListName('mini basket');
    const { url: imgUrl, label: imgAlt } = getProductImage(item);
    const { price } = item.prices;
    const currencyCode = price.currency;
    const newPrice = getProductNewPrice(item, currencyCode, locale, noZeroAfterDecimal, item.quantity);
    const oldPrice = getProductOldPrice(item, currencyCode, locale, noZeroAfterDecimal, item.quantity);
    const prices = {
        newPrice,
        oldPrice,
    };
    const rawPointsTotal = (((_a = item.configured_variant) === null || _a === void 0 ? void 0 : _a.price_points) || ((_b = item.product) === null || _b === void 0 ? void 0 : _b.price_points) || 0) * item.quantity;
    const totalPoints = formatPoints(rawPointsTotal, locale);
    const dispatch = useDispatch();
    const showError = useShowError();
    const stockInfo = getCartItemStockInfo(item, t);
    const stockInfoMessageVariant = stockInfo.qty < item.quantity || !stockInfo.availableForSale ? 'error' : 'info';
    const remove = async () => {
        setIsDeleting(true);
        const cartSessionId = getCartSessionId();
        const payload = {
            cart_id: cartSessionId,
            cart_item_id: Number(item.id),
            cart_item: item,
            accorTaggingEnabled,
            itemListName,
        };
        const resultAction = await dispatch(removeItem(payload));
        if (removeItem.rejected.match(resultAction)) {
            showError(resultAction.payload.errorMessage);
        }
        setIsDeleting(false);
    };
    if (!item.quantity)
        return null;
    const variants = extractVariantsFromProductName({
        name: ((_c = item.configured_variant) === null || _c === void 0 ? void 0 : _c.name) || ((_d = item.product) === null || _d === void 0 ? void 0 : _d.name),
    });
    const variantsArray = variants ? variants.split(/;| - /) : [];
    return (React.createElement("li", { className: "cart-item" },
        React.createElement("div", { className: "image" },
            React.createElement("img", { src: imgUrl, alt: imgAlt, onError: () => logImgLoadErrorToRelic(router.asPath, imgUrl) })),
        React.createElement("div", { className: "inner-wrapper" },
            React.createElement("div", { className: "description" },
                React.createElement("div", { className: "item-title" }, formatProductName({
                    name: item.product.name,
                    lang: locale,
                    siteFilters: productNameFilters || null,
                })),
                React.createElement("div", { className: "item-options" }, variantsArray.length > 0 &&
                    variantsArray
                        .map((variant) => variant ? (React.createElement("span", { className: "product-option test1", key: variant }, variant)) : null)
                        .filter(Boolean)),
                stockInfo.message && (React.createElement("div", { className: `stock-level ${stockInfoMessageVariant}-ui`, role: "alert" }, stockInfo.message))),
            React.createElement("div", { className: "inner-wrapper" },
                React.createElement(Quantity, { item: item }),
                React.createElement("div", { className: "price" },
                    React.createElement("span", { className: "cart-title" },
                        tLabel('price'),
                        ": "),
                    showPoints ? (React.createElement("div", { className: "price-wrapper" },
                        React.createElement("div", { className: "product-price", "aria-label": `${tLabel('points')}: ${item.product.price_points}` }, `${totalPoints} ${tLabel('points')}`))) : (React.createElement("div", { className: "price-wrapper" },
                        React.createElement(Prices, { show: true, prices: prices, className: "product-config-prices" })))))),
        React.createElement("div", { className: "remove" }, isDeleting ? (React.createElement(Loader, { size: 20 })) : (React.createElement(Remove, { item: item, onRemove: remove, icon: "icon-trash" })))));
};

export { ShoppingCartItemDrawer as S };
//# sourceMappingURL=ShoppingCartItemDrawer-rLthS1US.js.map
